/* Handy: Shopify-Inbox-Chatknopf ueber die Warenkorb-Leiste (product-quick-add) schieben, solange sie sichtbar ist.
   Der Knopf (.activator-nudge) steckt je nach Chat-Version eine oder zwei Shadow-DOM-Ebenen tief
   (shopify-chat > shopify-agent-runtime), deshalb wird jede Ebene mit dem Knopf gesucht.
   Der Omnisend-Teaser "10 € sichern" wandert auf dem Handy nach rechts und rutscht ebenfalls ueber die Leiste,
   sonst liegen Chat, Teaser und Leiste unten links uebereinander. */
(function () {
  var bar = document.querySelector('product-quick-add');
  if (!bar) return;
  var CSS = '.activator-nudge{transition:bottom .25s ease}:host([data-lll-up]) .activator-nudge{bottom:calc(20px + var(--lll-chat-up,0px))!important}';
  var TEASER = '@media (max-width:999px){[class*="omnisend-form-"][class*="-rectangle-teaser"]{left:auto!important;right:8px!important;transition:bottom .25s ease}'
    + 'html[data-lll-up] [class*="omnisend-form-"][class*="-rectangle-teaser"]{bottom:calc(8px + var(--lll-chat-up,0px))!important}}';
  var t = document.createElement('style'); t.id = 'lll-teaser-up'; t.textContent = TEASER; document.head.appendChild(t);
  var hosts = [];
  function find(el) {
    var root = el.shadowRoot;
    if (!root) return;
    if (root.querySelector('.activator-nudge') && hosts.indexOf(el) < 0) {
      var s = document.createElement('style'); s.id = 'lll-chat-up'; s.textContent = CSS; root.appendChild(s);
      hosts.push(el);
    }
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) if (all[i].shadowRoot) find(all[i]);
  }
  function sync() {
    var up = bar.classList.contains('is-visible') && window.innerWidth < 1000;
    document.documentElement.style.setProperty('--lll-chat-up', bar.offsetHeight + 'px');
    document.documentElement.toggleAttribute('data-lll-up', up);
    var chat = document.querySelector('shopify-chat');
    if (chat) find(chat);
    hosts.forEach(function (h) { h.toggleAttribute('data-lll-up', up); });
    return hosts.length;
  }
  new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('resize', sync);
  /* Der Chat baut sich spaet und in Etappen auf: suchen, bis der Knopf gefunden ist (max. 30 s). */
  var n = 0, timer = setInterval(function () { if (sync() || ++n > 40) clearInterval(timer); }, 750);
  sync();
})();
